import { Edit } from "lucide-react";
import React from "react";

interface Classification {
  id: number | string;
  display_name: string;
  name?: string;
}
interface Category {
  id: number | string;
  display_name: string;
  name?: string;
}

interface SeasonCardProps {
  image: string;
  title: string;
  subtitle?: string;
  season?: string;
  released: string | number;
  country: string;
  language: string;
  type: string;
  categories: Category[];
  classifications: Classification[];
  onEdit?: () => void;
  onMoreDetail?: () => void;
}

const SeasonCard: React.FC<SeasonCardProps> = ({
  image,
  title,
  subtitle = "",
  season = "Season 1",
  released,
  country,
  language,
  type,
  categories,
  classifications,
  onEdit,
  onMoreDetail,
}) => {
  return (
    <div className="bg-white rounded-2xl w-100  h-full w-full">
      {/* Poster */}
      <div className="rounded-xl overflow-hidden mb-3">
        <img
          src={image}
          alt={title}
          className="w-full h-48 object-cover rounded-xl"
        />
      </div>
      <div className="border border-gray-200 rounded-xl p-4">

        {/* Title */}
        <div className="text-left mb-3">
          <h2 className="text-base font-semibold">{subtitle}</h2>
          <h3 className="text-xl font-bold mt-1 text-gray-800">{season}</h3>
        </div>

        {/* Buttons */}
        <div className="flex justify-center gap-3 mb-4">
          <button
            onClick={onEdit}
            className="flex items-center gap-2 w-1/2 py-2 justify-center rounded-md text-black border text-lg font-bold hover:bg-gray-50 transition"
          >
            <Edit /> Edit
          </button>
          <button
            onClick={onMoreDetail}
            className="py-2 justify-center rounded-md bg-blue-600 w-1/2 text-white text-lg font-bold hover:bg-blue-700 transition"
          >
            More detail
          </button>
        </div>

        {/* Info grid */}
        <div className="grid grid-cols-2 gap-y-3 text-sm text-gray-700 mb-5">
          <div>
            <p className="font-semibold text-gray-500 text-xs">Released</p>
            <p>{released}</p>
          </div>
          <div>
            <p className="font-semibold text-gray-500 text-xs">Country</p>
            <p>{country}</p>
          </div>
          <div>
            <p className="font-semibold text-gray-500 text-xs">Language</p>
            <p>{language}</p>
          </div>
          <div>
            <p className="font-semibold text-gray-500 text-xs">Type</p>
            <p>{type}</p>
          </div>
        </div>

        {/* Categories */}
        <div className="mb-5">
          <p className="font-semibold text-gray-500 text-xs mb-1">Category</p>
          <div className="flex flex-wrap gap-2">
            {categories.map((cat, i) => (
              <span
                key={i}
                className="text-xs bg-gray-100 px-3 py-1 rounded-full text-gray-800"
              >
                {cat?.name || cat?.display_name || '-'}
              </span>
            ))}
          </div>
        </div>

        {/* Classifications */}
        <div>
          <p className="font-semibold text-gray-500 text-xs mb-1">
            Classifications
          </p>
          <div className="flex flex-wrap gap-2">
            {classifications.map((c) => (
              <span
                key={c.id}
                className="text-xs bg-gray-200 px-3 py-1 rounded-full text-gray-800"
              >
                {c.display_name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeasonCard;
